import AnimatedPage from "../components/AnimatedPage";
import CallToAction from "../components/CallToAction";
import Hero from "../components/Hero";
import FancyHeadingParagraph from "../components/FancyHeadingParagraph";
import HeadingParagraph from "../components/HeadingParagraph";
import HeadingSubheadingContent from "../components/HeadingSubheadingContent";
import Testimonials from "../components/Testimonials";

export default function AngelInvestors() {
	const testimonials = [
		{
			title: "The Growth Manager",
			text: "Only when you work as part of a Senior Management Team around a central data repository, kept up to date, do you really realise the operational benefits of centralising key corporate data into one easy to access location.",
			author: "Katy Davidson",
			company: "CFO Wearable Technologies Limited",
		},
		{
			title: "The Investment Manager",
			text: "Cost-effective diligencing of angel-stage investments, along with an associated kitemark validation would be of great benefit to the angel market – both the networks and prospective angel investors.",
			author: "[Need to get approval]",
			company: "Investment Manager, [xxx]",
		},
		{
			title: "The Professional",
			text: "Getting a client into a position where they can provide a draft disclosure letter schedule at the commencement of a transaction will reduce costs, speed up the transaction, and lessen the chance of its falling over right at the end.",
			author: "Rik Pancholi",
			company: "Director, Pattersons Commercial Law",
		},
	];
	return (
		<AnimatedPage>
			{/* <Hero h1Class="fs2-5rem fs2-5rem-sm" h1={["More Investible Companies", "Easier Due Diligence", "Higher Exit Valutations."]} buttonText="Learn How" buttonId="scrollDown" videoSrc="diligentsia_for_angel_investors.mp4" videoThumbnail="diligentsia-for-angel-investors.jpg" /> */}
			<Hero h1Class="fs2-5rem" h1={["More Investible Companies", "Easier Due Diligence", "Higher Exit Valutations."]} buttonText="Register as Investor" id='openRegisterPopup' dataShowPopup="registerInvestor" buttonId="scrollDown" videoSrc="diligentsia_for_angel_networks.mp4" videoThumbnail="diligentsia-for-angel-investors.jpg" />

			<div className="bg1">
				<div className="container dg gtcr1-lg gg2rem py5rem">
					<HeadingSubheadingContent heading="Can We Help Your Investments?" subheading="Meet Diligentsia" paragraph="Would you like to demonstrably improve returns across your investments? Earlier qualification? Quicker deals? Higher funding completion %? Would you like to better assess investment risk? It is currently difficult for you to truly assess risk and stage of development of the companies that are presented to you." />
				</div>
			</div>
			<div className="bg1">
				<div className="dg gtcr2-lg gg2rem container pb5rem">
					<HeadingParagraph heading="Would you like to offer cost effective due diligence to your target companies?" paragraph="Not currently cost effective for you to undertake thorough due diligence. The companies do not have the funds available to pay the networks." />
					<HeadingParagraph heading="Would you like to improve standards across across your portfolio companies?" paragraph="And save you time when assessing investment opportunities?" />
					<HeadingParagraph heading="Would you like to Increase interest amongst you and your fellow investors?" paragraph="Kitemarking will enable investors immediately to see which of your target companies is investment ready." />
					<HeadingParagraph heading="Flywheel effect." paragraph="Your network will gain competitive advantage through offering better quality companies that have been pre-vetted; you and your angels will make better returns, and more angels will flock to the platforms and networks which utilise the kitemarking." />
				</div>
			</div>
			<FancyHeadingParagraph
				content={[
					["Investment Ready Kitemarks", "Data room already? Seed Legals, or iDeals or DataSite? We organise it better to create more value.  No data room?  We simply create one within their existing cloud-based solution – Sharepoint/Drive/Dropbox."],
					["We are Data Room Agnostic", "Diligentsia has developed an ultra low-cost SaaS solution to act as a filter for the angel network, and get the companies “investment ready”, along with a kitemark (bronze, silver gold) to display to potential investors."],
				]}
			/>
			<Testimonials testimonials={testimonials} />
			<CallToAction heading="Ready to Maximise Your Investment Returns for as Little as &pound; 5 a Month?" />
		</AnimatedPage>
	);
}
